<template>
  <div>
		<el-container style="display:block;">
    <el-row :gutter="60" class="de-h-w">
			<el-col :span="6" class="de-el-col"><div class="de-title-name">数据图片:</div></el-col>
			<el-col :span="18" class="de-el-col">
				<div class="de-content">

					<div class="upload-img">
						<el-row :gutter="30">
							<div :span="8" v-for="(item,index) in headimg" :key="index" class="de-img-model"
							draggable="true"
							@dragstart="handleDragStart($event, item)"
							@dragover.prevent="handleDragOver($event, item)"
							@dragenter="handleDragEnter($event, item)"
							@dragend="handleDragEnd($event, item)"
							>
								<div v-if="!item" class="de-up-de-content">

									<input id="img01" class="up" @change="getImgBase(index)" type="file">
									<div class="de-img-up">+</div>
								</div>
								<div v-if="item" class="de-img">
									<p @click="delImg(index)">X</p>
									<img :src="item" />
								</div>
							</div>

						</el-row>
					</div>
					<div>
						<p>1.商品主图600*600像素正方形,小于50kb,保证图片不拉伸不变形</p>
						<p>2.保证图片不拉伸不变形</p>
						<p>3.上传后的图片将自动保存</p>

					</div>
				</div>
			</el-col>
		</el-row>
		<el-row :gutter="60" class="de-h-w">
			<el-col :span="6" class="de-el-col"><div class="de-title-name">数据描述:</div></el-col>
			<el-col :span="18" class="de-el-col">
				<div class="de-content">
					<el-input type="textarea" v-model="textarea"   class="disc"></el-input>
					<p>商品描述至少3个字符,最长50个字符</p>
				</div>

			</el-col>
		</el-row>
    <el-row :gutter="60" class="de-h-w">
    	<el-col :span="6" class="de-el-col"><div class="de-title-name">多描述标签:</div></el-col>
    	<el-col :span="18" class="de-el-col">
    		<el-tag
    		  :key="tag"
    		  v-for="tag in dynamicTags"
    		  closable
    		  :disable-transitions="false"
    		  @close="handleClose(tag)">
    		  {{tag}}
    		</el-tag>
    		<el-input
    		  class="input-new-tag"
    		  v-if="inputVisible"
    		  v-model="inputValue"
    		  ref="saveTagInput"
    		  size="small"
    		  @keyup.enter.native="handleInputConfirm"
    		  @blur="handleInputConfirm"
    		>
    		</el-input>
    		<el-button v-else class="button-new-tag" size="small" @click="showInput">添加新描述</el-button>
    	</el-col>
    </el-row>
		<el-row :gutter="60" class="de-h-w biaoqian">
			<el-col :span="6" class="de-el-col"><div class="de-title-name">数据标签:</div></el-col>
			<el-col :span="18" class="de-el-col">
				<div class="de-content">
					<el-input type="textarea" v-model="lable"   class="disc"></el-input>
				</div>

			</el-col>
		</el-row>
		<el-row :gutter="60" class="de-h-w">
			<input type="button" @click="saveDetail()" class="h-save"  value="保存"/>
		</el-row>
		</el-container>
  </div>

</template>
<style>


</style>
<script>

  export default {

    data() {
      return {
		id:this.$route.params.id,
        headimg: [''],
		textarea:'',
		dragging: null,
		itemModel:false,
		lable:'',
		token:window.localStorage.getItem('token'),
		userId:window.localStorage.getItem('id'),
		url:this.$store.getters.getUrl,
    dynamicTags: [],
    inputVisible: false,
    inputValue: ''
      };
    },
		created(){
		if(!window.localStorage.getItem('id')){
		  this.$router.push({ path: '/' })
		}
		//	var cip = returnCitySN["cip"];
// 			if(this.$store.getters.getRole != 'admins'){
// 					   if(cip !='117.9.19.251' && cip !='60.27.105.250' && cip !='60.27.106.235'){
// 						   this.$router.push({ path: '/' })
// 					   }
// 			}
			this.loadDetail();
		},
    methods: {
      handleClose(tag) {
                this.dynamicTags.splice(this.dynamicTags.indexOf(tag), 1);
              },

              showInput() {
                this.inputVisible = true;
                this.$nextTick(_ => {
                  this.$refs.saveTagInput.$refs.input.focus();
                });
              },

              handleInputConfirm() {
                let inputValue = this.inputValue;
                if (inputValue) {
                  this.dynamicTags.push(inputValue);
                }
                this.inputVisible = false;
                this.inputValue = '';
              },

      handleDragStart(e,item){
			this.dragging = item;
		},
		handleDragEnd(e,item){
			this.dragging = null
		},
		//首先把div变成可以放置的元素，即重写dragenter/dragover
		handleDragOver(e) {
			e.dataTransfer.dropEffect = 'move'// e.dataTransfer.dropEffect="move";//在dragenter中针对放置目标来设置!
		},
		handleDragEnter(e,item){
			e.dataTransfer.effectAllowed = "move"//为需要移动的元素设置dragstart事件
			if(item === this.dragging){
				return
			}
			const newItems = [...this.headimg]
			console.log(newItems)
			const src = newItems.indexOf(this.dragging)
			const dst = newItems.indexOf(item)

			newItems.splice(dst, 0, ...newItems.splice(src, 1))

			this.headimg = newItems
		},

			getImgBase(index) {

        let event = event || window.event;
        let file = event.target.files[0];
        let reader = new FileReader();
        //这个this指向的是vue
        reader.vue  = this
        reader.readAsDataURL(file);
        //在reader的load内部，this的指向是reader，所以使用自己的数据或者封装的vue方法，请使用this.vue.XXX
        reader.onload = function () {
          file.src = this.result

					this.vue.$set(this.vue.headimg, index , file.src);
					  let x = document.getElementById('img01').files[0];
					  let params =new FormData();
					  // params.append('file',x,x.name);
					  params.append('id',this.vue.id);
					  params.append('token',this.vue.token);
					  params.append('userId',this.vue.userId);
					  params.append('myfile',file)
					  console.log(params.get('myfile'))

					  let data = {
						id:this.vue.id,
						token:this.vue.token,
						userId:this.vue.userId,
						myfile:file
					  }
					  const axiosInstance = this.vue.$axios.create({
					  	headers: {'Content-Type': 'multipart/form-data'},// 设置传输内容的类型和编码
					  	withCredentials: true,// 指定某个请求应该发送凭据。允许客户端携带跨域cookie，也需要此配置

					  });

					  axiosInstance({
					  	method:'post',
					  	url:'http://'+this.vue.url+'/index.php/index/data/uploadImg',
					  	data:params

					  })
					  .then(res=>{
					  	if(res.data.code == 200){
					  		this.msg('图片保存成功','success');
					  	}else{
					  		this.msg('图片保存失败','error');
					  	}
					  })
					  .catch(err=>{

					  });

				}


			},
			dataURItoBlob (dataURI) {
			  // base64 解码
			  let byteString = window.atob(dataURI.split(',')[1]);
			  let mimeString = dataURI.split(',')[0].split(':')[1].split(';')[0];
			  let T = mimeString.split('/')[1]
			  let ab = new ArrayBuffer(byteString.length);
			  let ia = new Uint8Array(ab);
			  for (let i = 0; i < byteString.length; i++) {
				ia[i] = byteString.charCodeAt(i);
			  }
			  return new Blob([ab], {type: mimeString});
			},

			delImg(index){
				this.$set(this.headimg, index , '');
			},
			chose(index){
				if(this.items.length-index == 1){
					this.open()
				}else{
					this.itemModel = true;
				}

			},
			itemModelLeave(){
				this.itemModel = false;
			},
			loadDetail(){
				const axiosInstance = this.$axios.create({
					headers: {'Content-Type': 'application/json;charset=utf-8'},// 设置传输内容的类型和编码
					withCredentials: true,// 指定某个请求应该发送凭据。允许客户端携带跨域cookie，也需要此配置
				});
				axiosInstance({
					method:'post',
					url:'http://y31p.yoooooo.com/index.php/index/data/loadDetail',
					params:{
						id:this.id,
						token:this.token,
						userId:this.userId
					}
				})
				.then(res=>{
					if(res.data.code == 200){
						let dataD = res.data.data;
						this.$set(this.headimg, 0 , dataD.img_01);
						this.textarea =  dataD.describe;
            this.dynamicTags = dataD.duomiaoshu.split(',')
						this.lable =  dataD.lable;
					}else{
						this.msg('请登录!','error');
					}
				})
				.catch(err=>{

				});
			},
			saveDetail(){

				const axiosInstance = this.$axios.create({
					headers: {'Content-Type': 'application/json;charset=utf-8'},// 设置传输内容的类型和编码
					withCredentials: true,// 指定某个请求应该发送凭据。允许客户端携带跨域cookie，也需要此配置
				});
				axiosInstance({
					method:'post',
					url:'http://y31p.yoooooo.com/index.php/index/data/saveDetail',
					params:{
						id:this.id,
						token:this.token,
						userId:this.userId,
						textarea:this.textarea,
						lable:this.lable,
            describes:this.dynamicTags.toString()
            
					}
				})
				.then(res=>{
					if(res.data.code == 200){
						this.msg('保存成功','success');
					}else{
						this.msg('请登录!','error');
					}
				})
				.catch(err=>{

				});
			},
			msg(msg,type){
				this.$message({
				  message: msg,
				  type: type
				});
			},
		}
	}
</script>
<style>
  .el-tag + .el-tag {
      margin-left: 10px;
    }
    .button-new-tag {
      margin-left: 10px;
      height: 32px;
      line-height: 30px;
      padding-top: 0;
      padding-bottom: 0;
    }
    .input-new-tag {
      width: 90px;
      margin-left: 10px;
      vertical-align: bottom;
    }
	.de-h-w:nth-child(1),.biaoqian {
	    margin-bottom: 20px;
	    height: 200px;
			width: 70%;
			padding-left: 20%;
			margin-top: 50px;
	  }
	  .h-save{
		margin-left: 46%;
		width: 100px;
		height: 40px;
		background-color: orange;
		border-radius: 10px;
		color: #fff;
	  }
		.de-h-w:nth-child(2) {
		  margin-bottom: 20px;
		  height: 200px;
			width: 70%;
			padding-left: 20%;
		}
    .de-h-w:nth-child(3) {
      margin-bottom: 20px;
      height: 200px;
    	width: 70%;
    	padding-left: 20%;
    }
	  .de-el-col {
	    border-radius: 4px;
		height: 100%;
	  }
		.de-title-name{
			height: 100%;
			width: 100%;
			border: #fff 0px;
			text-align: right;
		}
		.disc textarea{
			height: 90px;
			border: none;
			background: #FAEBD7;
		}
		.de-item-name{
			background: antiquewhite;
			height: 50px;
			text-align: center;
			line-height: 50px;
			float: left;
			width: 15%;
			margin-left: 10px;
			margin-bottom: 10px;
		}
		.de-item-two{
			position: absolute;
			top: 50px;
			left: 0;
			background: #FFFFFF;
			width: 97%;
			height: 50%;
			margin-left: 10px;
			box-shadow: 0 2px 12px 0 rgba(0, 0, 0, 0.1);
			border:3px solid aliceblue;
		}
		.de-search-model{
			margin-left: 20px;
			margin-top: 10px;
		}
		.de-search-model span{
			margin-left: 10px;
			font-size: 14px;
		}
		.de-search-but{
			background: #939aa0;

		}
		.de-item-model{
			margin-left: 17px;
			margin-top: 10px;
		}

		.de-item-model label{
			float: left;
			font-size: 14px;
			margin-right: 10px;
			width: 90px;
			margin-bottom: 10px;
		}

		.de-itemname{
			float: left;
			margin-left: 5px;
			margin-top: 3px;
		}


	  .de-content{
			width: 100%;
			height: 100%;
			position: relative;
			/* background: antiquewhite; */
		}
		.de-img-model{
			float: left;
			width: 33.3333%;

		}
		.de-up-de-content{
			position: relative;
			height: 180px;
			width: 185px;
			margin-left: 20px;
		}

		.de-img-up{
			background: antiquewhite;
			height: 180px;
			text-align: center;
			line-height: 180px;
			font-size: 46px;

		}
	  .up{
	        opacity:0;
	        filter:alpha(opacity=0);
	        height: 100%;
	        width: 100%;
	        position: absolute;
	        top: 0;
	        left: 0;
	        z-index: 9;
	    }
			.de-img {
				height: 180px;
				width: 33.333%;
				position: relative;
				margin-left: 20px;
			}
			.de-img img{
				height: 180px;
				width: 180px;
			}
			.de-img p{
				height: 30px;
				width: 30px;
				background: antiquewhite;
				position: absolute;
				top: -30px;
				left: -15px;
				z-index: 9;
				border-radius: 30px;
				text-align: center;
				line-height: 30px;
			}
</style>



// WEBPACK FOOTER //
// src/components/main/home.vue